import { Table } from "antd";
import styled from "styled-components/macro";
import { COLORS } from "../../../../../../../layout/theme";

export const ContainerDiv = styled.div`
	width: 100%;
	overflow: auto;
	direction: rtl;

	scrollbar-width: auto;
	scrollbar-color: ${COLORS.SkeletonGrey} ${COLORS.White};

	::-webkit-scrollbar {
		width: 7px;
	}

	::-webkit-scrollbar-track {
		background: ${COLORS.White};
	}

	::-webkit-scrollbar-thumb {
		background-color: ${COLORS.SkeletonGrey};
		border-radius: 10px;
		border: 2px solid ${COLORS.White};
	}

	.ant-table table {
		background-color: ${(props) =>
			props.containerBackground
				? props.containerBackground
				: COLORS.LightGrey} !important;
	}
`;

export const AntdTable = styled(Table)`
	direction: ltr;

	.ant-empty-description {
		visibility: hidden;
	}

	.ant-empty-description::after {
		content: "No hay productos";
		visibility: visible;
		display: block;
		margin-top: -10px;
	}

	& .noBackground,
	& .noBackground:hover {
		background-color: ${COLORS.LightGrey} !important;
		border: none;
	}

	.ant-table-thead > tr > th {
		background: ${(props) =>
			props.background ? props.background : COLORS.Primary};
	}

	.ant-table-row {
		background: ${(props) =>
			props.rowBackground ? props.rowBackground : COLORS.White};
	}

	.ant-table-thead
		> tr
		> th:not(:last-child):not(.ant-table-selection-column):not(
			.ant-table-row-expand-icon-cell
		):not([colspan])::before {
		background-color: ${(props) =>
			props.background ? props.background : COLORS.Primary};

		div {
			color: ${(props) =>
				props.background ? props.background : COLORS.Primary};
		}
	}

	.ant-table-container table > thead > tr:first-child th:first-child {
		border-radius: 20px 0 0 0;
	}

	.ant-table-container table > thead > tr:first-child th:last-child {
		border-radius: 0 20px 0 0;
	}

	.ant-table-row td::-webkit-scrollbar {
		display: none;
	}
`;
